import { render, staticRenderFns } from "./SalePageDongguangkanghua01.vue?vue&type=template&id=84bc8d82&scoped=true"
import script from "./SalePageDongguangkanghua01.vue?vue&type=script&lang=js"
export * from "./SalePageDongguangkanghua01.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84bc8d82",
  null
  
)

export default component.exports